import { useDebounce, useRequest } from 'ahooks'
import { Descriptions, Input, Select, Spin, Typography } from 'antd'
import axios from 'axios'
import React from 'react'

import { useIsSystemAdmin } from '../admin.hooks'

enum ImpactEntity {
  Post = 'Post',
  User = 'User',
  Group = 'Group',
}

export const ImpactQueryComponent = () => {
  const [id, setId] = React.useState('')
  const [type, setType] = React.useState<ImpactEntity>(ImpactEntity.User)
  const debouncedId = useDebounce(id, { wait: 500 })
  const isSystemAdmin = useIsSystemAdmin()

  if (!isSystemAdmin) {
    return null
  }

  const { data, loading } = useRequest(
    () => {
      return axios.request({
        method: 'GET',
        url: '/api/impact',
        params: {
          entity: type,
          id: debouncedId,
          email: debouncedId,
        },
      })
    },
    {
      ready: !!debouncedId && !!type,
      refreshDeps: [debouncedId, type],
    }
  )

  const impact: { dbImpact?: number; dbInfo?: any } = data?.data || { dbImpact: 0 }

  const inputFields = (
    <div style={{ display: 'flex', marginBottom: 24 }}>
      <Select value={type} onSelect={(value: any) => setType(value)} placeholder='查询类型'>
        <Select.Option value={ImpactEntity.Group}>群组</Select.Option>
        <Select.Option value={ImpactEntity.User}>用户</Select.Option>
        <Select.Option value={ImpactEntity.Post}>帖子</Select.Option>
      </Select>
      <Input
        style={{ marginLeft: 8 }}
        value={id}
        onChange={(e) => setId(e.target.value)}
        placeholder='类型 id, 用户类型支持 email 查询'
      />
    </div>
  )

  return (
    <div
      style={{
        padding: 24,
        margin: '0 auto',
        maxWidth: 800,
        width: '100%',
      }}
    >
      <Typography.Title level={5}>影响力查询</Typography.Title>
      {inputFields}
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Spin delay={300} size='large' />
        </div>
      ) : (
        <Descriptions title={`总影响力: ${impact.dbImpact}`}>
          {Object.keys(impact.dbInfo || {}).map((key) => (
            <Descriptions.Item key={key} label={key}>
              {impact.dbInfo[key]}
            </Descriptions.Item>
          ))}
        </Descriptions>
      )}
    </div>
  )
}
